module.exports = __webpack_public_path__ + "mo/img/05_Interaction-Design.b2224bea.png";